import staffSettingApi from "api/staffSettingApi";

export { useStaffActions };

function useStaffActions() {
   const getStaffSettingList = async (params) => {
      try {
         return await staffSettingApi.gets(params);
      } catch (error) {
         console.log(error);
         throw error;
      }
   };

   const inviteMember = async (data) => {
      try {
         return await staffSettingApi.inviteMember(data);
      } catch (error) {
         console.log(error);
         throw error;
      }
   };

   const addStoreMember = async (userID, data) => {
      try {
         return await staffSettingApi.addStoreMember(userID, data);
      } catch (error) {
         console.log(error);
         throw error;
      }
   };

   const getStaffSettingStoreDetail = async (id) => {
      try {
         return await staffSettingApi.getStaffSettingStoreDetail(id);
      } catch (error) {
         console.log(error);
         throw error;
      }
   };

   const updateStaffRole = async (userID, data) => {
      try {
         return await staffSettingApi.updateStaffRole(userID, data);
      } catch (error) {
         console.log(error);
         throw error;
      }
   };

   const getStaffSettingRoleDetail = async (id) => {
      try {
         return await staffSettingApi.getStaffSettingRoleDetail(id);
      } catch (error) {
         console.log(error);
         throw error;
      }
   };

   const getPagedStaffList = async (params) => {
      try {
         return await staffSettingApi.getPagedStaffList(params);
      } catch (error) {
         console.log(error);
         throw error;
      }
   };

   const getStaffById = async (id) => {
      try {
         return await staffSettingApi.getStaffById(id);
      } catch (error) {
         console.log(error);
         throw error;
      }
   };

   const getStoreMember = async (userId, storeId) => {
      try {
         return await staffSettingApi.getStoreMember(userId, storeId);
      } catch (error) {
         console.log(error);
         throw error;
      }
   };

   const deleteStoreMemberById = async (id) => {
      try {
         return await staffSettingApi.deleteStoreMemberById(id);
      } catch (error) {
         console.log(error);
         throw error;
      }
   }

   return {
      deleteStoreMemberById,
      getStoreMember,
      getStaffById,
      getPagedStaffList,
      getStaffSettingList,
      getStaffSettingStoreDetail,
      inviteMember,
      addStoreMember,
      getStaffSettingRoleDetail,
      updateStaffRole,
   };
}
